export default __webpack_public_path__ + "static/media/02.63036540.jpg";